import React from "react";
import { Navigate } from "react-router-dom";
import AccessDenied from "../pages/error/AccessDenied";

export default function AdminProtectedRoute({ children }) {
  // Get user safely
  const userJSON = localStorage.getItem("user");
  let user = null;

  try {
    user = userJSON ? JSON.parse(userJSON) : null;
  } catch (err) {
    user = null;
  }

  if (!user || !user.is_admin) {
    return <AccessDenied />;
  }

  // User exists and is admin → render the protected component
  return children;
}
